<template>
  <div v-if="isActive">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TabStripItem',
  props: {
    title: String,
    visible: {
      type: Boolean,
      default: true,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    activate() {
      this.isActive = true;
    },
    deactivate() {
      this.isActive = false;
    },
  },
  created() {
    if (!this.$parent.isTabs) {
      this.$destroy();
      throw new Error('You should wrap PwTabStripItem on a PwTabStrip');
    }
    this.$parent.tabItems.push(this);
  },
  beforeDestroy() {
    const index = this.$parent.tabItems.indexOf(this);
    if (index >= 0) {
      this.$parent.tabItems.splice(index, 1);
    }
  },
};
</script>
